import { render, staticRenderFns } from "./RenderPage.vue?vue&type=template&id=4532dc48&scoped=true"
import script from "./RenderPage.vue?vue&type=script&lang=js"
export * from "./RenderPage.vue?vue&type=script&lang=js"
import style0 from "./RenderPage.vue?vue&type=style&index=0&id=4532dc48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4532dc48",
  null
  
)

export default component.exports